<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :model="filterData" :inline="true">
            <el-form-item>
              <el-button type="primary" @click="formVisible = true">添加菜单</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border row-key="id" default-expand-all>
        <el-table-column label="菜单" prop="name"></el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click="addChildren(scope.row)">添加子菜单</el-button>
            <el-button @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      :title="`${modalTit}菜单`"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formInline" :model="formData" :rules="ruleValidate" label-width="100px" @submit.native.prevent>
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="formData.url"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-input v-model="formData.icon"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="formData.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Menus',
  data () {
    return {
      filterData: {
        name: ''
      },
      records: [],
      formData: {
        parents: [],
        name: '',
        url: '',
        icon: '',
        sort: 1
      },
      ruleValidate: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      },
      formVisible: false,
      modalTit: '',
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      request.get('menus', this.filterData).then(res => {
        this.records = res.data
        loading.close()
      })
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      this.formData = row
      this.formVisible = true
    },
    cancel() {
      this.formVisible = false
      this.formData = {}
    },
    save () {
      if (this.formData.id) {
        request.put('menus/' + this.formData.id, this.formData).then(()=>{
          this.getList()
          this.formVisible = false
          this.formData = {
            parents: [],
            name: '',
            url: '',
            sort: 1
          }
        }).catch(()=>{
          console.log('数据错误')
        })
      } else {
        request.post('menus', this.formData).then(()=>{
          this.getList()
          this.formVisible = false
          this.formData = {
            parents: [],
            name: '',
            url: '',
            sort: 1
          }
        }).catch(()=>{
          console.log('数据错误')
        })
      }
    },
    del () {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    addChildren(row) {
      let parents = []
      if (row.parents) {
        parents = row.parents
        parents.push(row.id)
      } else {
        parents = [row.id]
      }
      this.$set(this.formData, 'parent_id', row.id)
      this.$set(this.formData, 'parents', parents)
      this.modalTit = '添加'
      this.formVisible = true
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
